// Every `*_controller.js` here registers itself: esbuild-rails resolves the
// glob at build time and names each one after its file
// (`mobile_nav_controller.js` → data-controller="mobile-nav").
//
// clowk-phlex brings its own controllers (metrics-chart, dropdown, popover…).

import { registerClowkPhlex } from "@clowk/phlex"

import { application } from "./application"
import controllers from "./**/*_controller.js"

controllers.forEach((controller) => {
  application.register(controller.name, controller.module.default)
})

registerClowkPhlex(application)
